if(typeof require !== 'undefined'){
    var $ = (typeof window.$ === 'function') ? window.$ : require('jquery');
}

class MemberForm {
    static init($context = null) {
        var selector = "[data-list='members-removal']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('member_form_instance')) return;

            $(element).data('member_form_instance', new MemberForm(element))

        });
    }

    constructor(element) {
        //console.log('MemberForm init on ', element)
        this.version = '0.0.1'
        this.element = element;
        this.$element = $(element);
        this.owner = this.$element.find('[name="rootOwner"]').val();
        this.list = this.$element.find('[name="list"]').val();
        this.token = this.$element.find('[name="_token"]').val();


        this.$submitBtn = this.$element.find('button[type="submit"][name="submit"]');


        this.$element.on('ajax-form.done', function (event, response) {

            this.$element.data('ignore_messages', false);

            if(response.status === 'ok'){
                this.$submitBtn.removeClass('d-none');
            }else{
                this.$submitBtn.addClass('d-none');
            }

        }.bind(this))
    }
}


if (typeof module === "object" && typeof module.exports === "object"){

    MemberForm.init()
    //node modules support
    module.exports = MemberForm;
}else{
    $(function(){
        MemberForm.init()
    });
}